export const SET_ONLINE = 'SET_ONLINE'

export const SET_SYNC_IN_PROGRESS = 'SET_SYNC_IN_PROGRESS'
export const CLEAR_SYNC_IN_PROGRESS = 'CLEAR_SYNC_IN_PROGRESS'
